import React from 'react';
import { FiCheckCircle, FiAlertCircle, FiX } from 'react-icons/fi';

/**
 * Popup de resultado do pagamento — mostra sucesso (compra realizada) ou erro.
 * Controlado por `open`; fecha ao clicar no X, no fundo, ou no botão de ação.
 */
export default function PaymentResultModal({
  open,
  type = 'success',
  title,
  message,
  actionLabel,
  onAction,
  onClose,
}) {
  if (!open) return null;

  const success = type === 'success';
  const accent = success ? '#22c55e' : '#ef4444';
  const Icon = success ? FiCheckCircle : FiAlertCircle;

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(3px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 11000, // acima do modal de pagamento (10000) para o erro aparecer
        padding: 16,
        animation: 'prm-fade 0.2s ease-out',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 420,
          background: '#141414',
          border: '1px solid rgba(255, 215, 0, 0.25)',
          borderRadius: 14,
          padding: '28px 24px',
          textAlign: 'center',
          boxShadow: '0 16px 48px rgba(0, 0, 0, 0.55)',
          position: 'relative',
          animation: 'prm-pop 0.22s ease-out',
        }}
      >
        <button
          type="button"
          aria-label="Fechar"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            background: 'transparent',
            border: 'none',
            color: '#aaa',
            cursor: 'pointer',
            fontSize: 20,
            lineHeight: 1,
            display: 'inline-flex',
          }}
        >
          <FiX />
        </button>

        <div
          style={{
            width: 64,
            height: 64,
            margin: '0 auto 16px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: `${accent}1a`,
            border: `2px solid ${accent}`,
            color: accent,
            fontSize: 34,
          }}
        >
          <Icon />
        </div>

        <h2 style={{ color: '#fff', fontSize: 20, fontWeight: 800, margin: '0 0 8px' }}>{title}</h2>
        <p style={{ color: '#cfcfcf', fontSize: 14, lineHeight: 1.5, margin: '0 0 22px' }}>{message}</p>

        <button
          type="button"
          onClick={onAction || onClose}
          style={{
            width: '100%',
            padding: '14px',
            background: '#ffd700',
            color: '#1a1a1a',
            border: 'none',
            borderRadius: 8,
            fontWeight: 800,
            fontSize: 15,
            cursor: 'pointer',
          }}
        >
          {actionLabel || 'Ok'}
        </button>
      </div>

      <style>{`
        @keyframes prm-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes prm-pop { from { opacity: 0; transform: translateY(12px) scale(0.98); } to { opacity: 1; transform: none; } }
      `}</style>
    </div>
  );
}
